/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LossOfProductionMetricCreateRequest
 */
export interface LossOfProductionMetricCreateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LossOfProductionMetricCreateRequest
     */
    name: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LossOfProductionMetricCreateRequest
     */
    lc: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LossOfProductionMetricCreateRequest
     */
    licenseFeatures: Array<string>;
    /**
     * List of generator status keys of the global default variant
     * @type {Array<string>}
     * @memberof LossOfProductionMetricCreateRequest
     */
    generatorStatusKeys: Array<string>;
}

/**
 * Check if a given object implements the LossOfProductionMetricCreateRequest interface.
 */
export function instanceOfLossOfProductionMetricCreateRequest(value: object): value is LossOfProductionMetricCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('lc' in value) || value['lc'] === undefined) return false;
    if (!('licenseFeatures' in value) || value['licenseFeatures'] === undefined) return false;
    if (!('generatorStatusKeys' in value) || value['generatorStatusKeys'] === undefined) return false;
    return true;
}

export function LossOfProductionMetricCreateRequestFromJSON(json: any): LossOfProductionMetricCreateRequest {
    return LossOfProductionMetricCreateRequestFromJSONTyped(json, false);
}

export function LossOfProductionMetricCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LossOfProductionMetricCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'lc': json['lc'],
        'licenseFeatures': json['licenseFeatures'],
        'generatorStatusKeys': json['generatorStatusKeys'],
    };
}

export function LossOfProductionMetricCreateRequestToJSON(json: any): LossOfProductionMetricCreateRequest {
    return LossOfProductionMetricCreateRequestToJSONTyped(json, false);
}

export function LossOfProductionMetricCreateRequestToJSONTyped(value?: LossOfProductionMetricCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'lc': value['lc'],
        'licenseFeatures': value['licenseFeatures'],
        'generatorStatusKeys': value['generatorStatusKeys'],
    };
}

